import createReducer from '../../../../../../../helpers/createReducer';
import { updateItemsAndPackagesSkusSearchQuery } from '../../../../../actions/reports/items-and-packages-skus';

const initialState = {};

const updateSearchQueryHandler = action => ({
  [action.toString()]: (_, { payload: searchQuery }) => searchQuery
});

export default createReducer(initialState, {
  ...updateSearchQueryHandler(updateItemsAndPackagesSkusSearchQuery)
});
